import { useMemo } from "react";
import PropTypes from "prop-types";
import Message from "./index";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import LoadingAnimation from "basicComponents/LoadingAnimation/LoadingAnimation";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  body: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  messageBox: {
    borderLeft: "none",
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
}));

function LoadingMessage({ onClose }) {
  const classes = useStyles();

  const header = useMemo(
    () => (
      <div className={classes.header}>
        <span>
          <FormattedMessage {...messages.message_loading} />
        </span>
      </div>
    ),
    [classes.header],
  );

  const body = useMemo(
    () => (
      <div className={classes.body}>
        <LoadingAnimation />
      </div>
    ),
    [classes.body],
  );

  return (
    <Message
      key="message"
      className={classes.messageBox}
      onClose={onClose}
      header={header}
      body={body}
    />
  );
}

LoadingMessage.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default withRouter(LoadingMessage);
